import React, { useState } from 'react';
import { Checkbox } from '../../../components/ui/Checkbox';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const PrivacySettings = ({ onSave }) => {
  const [dataCollection, setDataCollection] = useState(true);
  const [performanceAnalytics, setPerformanceAnalytics] = useState(true);
  const [shareProgress] = useState(false);
  const [thirdPartySharing] = useState(false);

  const handleSave = () => {
    const settings = {
      dataCollection,
      performanceAnalytics,
      shareProgress,
      thirdPartySharing
    };
    onSave(settings);
  };

  const handleResetProgress = () => {
    if (window.confirm('Are you sure you want to reset all your progress? This action cannot be undone.')) {
      onSave({ type: 'reset-progress' });
    }
  };

  const handleDeleteAccount = () => {
    if (window.confirm('Are you sure you want to delete your account? All your data will be permanently removed. This action cannot be undone.')) {
      onSave({ type: 'delete-account' });
    }
  };

  return (
    <div className="space-y-8">
      <div className="space-y-4">
        <h3 className="text-base font-semibold text-foreground flex items-center gap-2">
          <Icon name="Shield" size={18} color="var(--color-primary)" />
          Data & Privacy Controls
        </h3>

        <Checkbox
          label="Data Collection for Coaching Improvement"
          description="Allow EME to analyze your responses to improve AI coaching quality"
          checked={dataCollection}
          onChange={(e) => setDataCollection(e?.target?.checked)}
        />

        <Checkbox
          label="Performance Analytics"
          description="Track detailed performance metrics to provide personalized insights"
          checked={performanceAnalytics}
          onChange={(e) => setPerformanceAnalytics(e?.target?.checked)}
        />

        <Checkbox
          label="Share Progress with Team (Coming Soon)"
          description="Team visibility is coming soon. Your progress is private until the feature launches."
          checked={shareProgress}
          disabled
        />
      </div>
      <div className="bg-muted/50 rounded-lg p-4">
        <h4 className="text-sm font-semibold text-foreground mb-2 flex items-center gap-2">
          <Icon name="Info" size={16} color="var(--color-primary)" />
          How We Use Your Data
        </h4>
        <ul className="space-y-2 text-sm text-muted-foreground">
          <li className="flex items-start gap-2">
            <Icon name="Check" size={14} className="mt-0.5 flex-shrink-0" />
            <span>Your responses are used to train and improve AI coaching algorithms</span>
          </li>
          <li className="flex items-start gap-2">
            <Icon name="Check" size={14} className="mt-0.5 flex-shrink-0" />
            <span>Performance data helps personalize your coaching experience</span>
          </li>
          <li className="flex items-start gap-2">
            <Icon name="Check" size={14} className="mt-0.5 flex-shrink-0" />
            <span>We never sell your personal information to third parties</span>
          </li>
          <li className="flex items-start gap-2">
            <Icon name="Check" size={14} className="mt-0.5 flex-shrink-0" />
            <span>All data is encrypted and stored securely</span>
          </li>
        </ul>
      </div>
      <Button 
        variant="default" 
        onClick={handleSave}
        iconName="Save"
        iconPosition="left"
      >
        Save Privacy Settings
      </Button>
      <div className="h-px bg-border" />
      <div className="space-y-4">
        <h3 className="text-base font-semibold text-foreground flex items-center gap-2">
          <Icon name="AlertTriangle" size={18} color="var(--color-warning)" />
          Data Management
        </h3>

        <div className="space-y-3">
          <div className="flex items-start justify-between gap-4 p-4 bg-muted/50 rounded-lg">
            <div>
              <h4 className="text-sm font-medium text-foreground mb-1">Reset Progress</h4>
              <p className="text-sm text-muted-foreground">Clear all coaching history and start fresh. Your account settings will be preserved.</p>
            </div>
            <Button 
              variant="outline" 
              onClick={handleResetProgress}
              iconName="RotateCcw"
              iconPosition="left"
            >
              Reset
            </Button>
          </div>

          <div className="flex items-start justify-between gap-4 p-4 bg-destructive/10 border border-destructive/20 rounded-lg">
            <div>
              <h4 className="text-sm font-medium text-foreground mb-1">Delete Account</h4>
              <p className="text-sm text-muted-foreground">Permanently delete your account and all associated data. This action cannot be undone.</p>
            </div>
            <Button 
              variant="destructive" 
              onClick={handleDeleteAccount}
              iconName="Trash2"
              iconPosition="left"
            >
              Delete
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacySettings;
